// Angular import
import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';

// project import
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppToastsComponent } from './shared/components/app-toasts/app-toasts.component';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, NgxSpinnerModule, AppToastsComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  // imports: [RouterOutlet, SpinnerComponent]
})
export class AppComponent {
  title = 'Order Exchange App';
}
